module.exports = [
	{
		"id": "30085DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30085DC1/640/30085DC1.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Zawór sztorcowy i bojler w rozmiarze M",
		"textblock_1st_text": "30085DC1",
		"textblock_2nd_text": "No value for EndUserShort",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/30085DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30339DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30339DC1/640/30339DC1.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Zawór sztorcowy i bojler w rozmiarze M",
		"textblock_1st_text": "30339DC1",
		"textblock_2nd_text": "No value for EndUserShort",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/30339DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325001/640/30325001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Wylewka i bojler w rozmiarze L",
		"textblock_1st_text": "30325001",
		"textblock_2nd_text": "GROHE RED Duo kitchen tap (L-spout) with filter set and L size boiler for instant boiling water. Chrome finish. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/30325001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30325DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30325DC1/640/30325DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Wylewka i bojler w rozmiarze L",
		"textblock_1st_text": "30325DC1",
		"textblock_2nd_text": "GROHE RED Duo kitchen tap (L-spout) with filter set and L size boiler for instant boiling water. Matte stainless steel look finish. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/30325DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327DC1/640/30327DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Wylewka i bojler w rozmiarze M",
		"textblock_1st_text": "30327DC1",
		"textblock_2nd_text": "GROHE RED Duo kitchen tap (L-spout) with filter set and M size boiler for instant boiling water. Matte stainless steel look. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/30327DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327001/640/30327001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Wylewka i bojler w rozmiarze M",
		"textblock_1st_text": "30327001",
		"textblock_2nd_text": "GROHE RED Duo kitchen tap (L-spout) with filter set and M size boiler for instant boiling water. Chrome finish. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/30327001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30339001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30339001/640/30339001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Zawór sztorcowy i bojler w rozmiarze M",
		"textblock_1st_text": "30339001",
		"textblock_2nd_text": "GROHE RED Mono kitchen tap (L-spout) with filter set and M size boiler for instant boiling water. Chrome finish. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/30339001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079DC1/640/30079DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Wylewka i bojler w rozmiarze L",
		"textblock_1st_text": "30079DC1",
		"textblock_2nd_text": "GROHE RED Duo kitchen tap (C-spout) with filter set and L size boiler for instant boiling water. Matte stainless steel look. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/30079DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30079001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30079001/640/30079001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Wylewka i bojler w rozmiarze L",
		"textblock_1st_text": "30079001",
		"textblock_2nd_text": "GROHE RED Duo kitchen tap (C-spout) with filter set and L size boiler for instant boiling water. Chrome finish. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/30079001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083DC1/640/30083DC1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Wylewka i bojler w rozmiarze M",
		"textblock_1st_text": "30083DC1",
		"textblock_2nd_text": "GROHE RED Duo kitchen tap (C-spout) with filter set and M size boiler for instant boiling water. Matte stainless steel look. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/30083DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083001/640/30083001.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Wylewka i bojler w rozmiarze M",
		"textblock_1st_text": "30083001",
		"textblock_2nd_text": "GROHE RED Duo kitchen tap (C-spout) with filter set and M size boiler for instant boiling water. Chrome finish. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/30083001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30080001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30080001/640/30080001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Zawór sztorcowy z bojlerem w rozmiarze L",
		"textblock_1st_text": "30080001",
		"textblock_2nd_text": "GROHE RED Mono kitchen tap (C-spout) with filter set and L size boiler for instant boiling water. Chrome finish. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/30080001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30085001",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30085001/640/30085001.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Zawór sztorcowy i bojler w rozmiarze M",
		"textblock_1st_text": "30085001",
		"textblock_2nd_text": "GROHE RED Mono kitchen tap (C-spout) with filter set and M size boiler for instant boiling water. Chrome finish. A-rated energy efficiency and safety features",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/30085001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083DL1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083DL1/640/30083DL1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Wylewka i bojler w rozmiarze M",
		"textblock_1st_text": "30083DL1",
		"textblock_2nd_text": "GROHE RED Duo kitchen tap with high C-spout in Brushed Warm Sunset. Includes filter set and M size boiler for instant boiling water. A-rated energy efficiency and safety features. 30083DL1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/30083DL1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083AL1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083AL1/640/30083AL1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Wylewka i bojler w rozmiarze M",
		"textblock_1st_text": "30083AL1",
		"textblock_2nd_text": "GROHE RED Duo kitchen tap with high C-spout in Brushed Hard Graphite. Includes filter set and M size boiler for instant boiling water. A-rated energy efficiency and safety features. 30083AL1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/30083AL1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327DL1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327DL1/640/30327DL1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Wylewka i bojler w rozmiarze M",
		"textblock_1st_text": "30327DL1",
		"textblock_2nd_text": "GROHE RED Duo kitchen tap with high L-spout in Brushed Warm Sunset. Includes filter set and M size boiler for instant boiling water. A-rated energy efficiency and safety features. 30327DL1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/30327DL1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498DC1/640/31498DC1.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Zestaw startowy Mono z wylewką w kształcie C ",
		"textblock_1st_text": "31498DC1",
		"textblock_2nd_text": "GROHE Blue Home Mono starter kit: single-lever pillar tap for filtered, chilled and sparkling water, with Bluetooth® & WIFI*. Includes cooler unit, filter and CO2 carbonization bottle. High swivel C-spout, stainless steel-look.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/31498DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498001",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498001/640/31498001.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Zestaw startowy Mono z wylewką w kształcie C ",
		"textblock_1st_text": "31498001",
		"textblock_2nd_text": "GROHE Blue Home Mono starter kit: single-lever pillar tap for filtered, chilled and sparkling water, with Bluetooth® & WIFI*. Includes cooler unit, filter and CO2 carbonization bottle. High swivel C-spout, chrome finish.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/31498001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31539DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31539DC0/640/31539DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-spout starter kit with pull-out mousseur",
		"textblock_1st_text": "31539DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: single-lever kitchen mixer for filtered, chilled and sparkling water, with Bluetooth® & WIFI*. Includes cooler unit, filter and CO2 carbonization bottle. High swivel L-spout with pull-out spray head, stainless steel-look.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/31539DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31539000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31539000/640/31539000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "L-spout starter kit with pull-out mousseur",
		"textblock_1st_text": "31539000",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: single-lever kitchen mixer for filtered, chilled and sparkling water, with Bluetooth® & WIFI*. Includes cooler unit, filter and CO2 carbonization bottle. High swivel L-spout with pull-out spray head, chrome finish.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/31539000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31541DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31541DC0/640/31541DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-spout starter kit with pull-out mousseur",
		"textblock_1st_text": "31541DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: single-lever kitchen mixer for filtered, chilled and sparkling water, with Bluetooth® & WIFI*. Includes cooler unit, filter and CO2 carbonization bottle. High swivel C-spout with pull-out spray head, stainless steel-look",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/31541DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31541000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31541000/640/31541000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "C-spout starter kit with pull-out mousseur",
		"textblock_1st_text": "31541000",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: single-lever kitchen mixer for filtered, chilled and sparkling water, with Bluetooth® & WIFI*. Includes cooler unit, filter and CO2 carbonization bottle. High swivel C-spout with pull-out spray head, chrome finish.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/31541000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31543DC0",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31543DC0/640/31543DC0.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-spout starter kit with pull-out mousseur",
		"textblock_1st_text": "31543DC0",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: single-lever kitchen mixer for filtered, chilled and sparkling water, with Bluetooth® & WIFI*. Includes cooler unit, filter and CO2 carbonization bottle. High swivel U-spout with pull-out spray head, stainless steel-look.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/31543DC0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31543000",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31543000/640/31543000.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "U-spout starter kit with pull-out mousseur",
		"textblock_1st_text": "31543000",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: single-lever kitchen mixer for filtered, chilled and sparkling water, with Bluetooth® & WIFI*. Includes cooler unit, filter and CO2 carbonization bottle. High swivel U-spout with pull-out spray head, chrome finish.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/31543000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456DC1/640/31456DC1.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Zestaw startowy z wylewką w kształcie U",
		"textblock_1st_text": "31456DC1",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: single-lever kitchen mixer for filtered, chilled and sparkling water, with Bluetooth® & WIFI*. Includes cooler unit, filter and CO2 carbonization bottle. High swivel U-spout, stainless steel-look.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/31456DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31456001",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31456001/640/31456001.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Zestaw startowy z wylewką w kształcie U",
		"textblock_1st_text": "31456001",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: single-lever kitchen mixer for filtered, chilled and sparkling water, with Bluetooth® & WIFI*. Includes cooler unit, filter and CO2 carbonization bottle. High swivel U-spout, chrome finish.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/31456001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498DL1",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498DL1/640/31498DL1.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Zestaw startowy Mono z wylewką w kształcie C ",
		"textblock_1st_text": "31498DL1",
		"textblock_2nd_text": "GROHE Blue Home Mono starter kit: pillar tap in Brushed Warm Sunset for filtered, chilled and sparkling water, with Bluetooth® & WIFI*, high C-spout. Includes cooler unit, filter and CO2 carbonization bottle. 31498DL1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/31498DL1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31498AL1",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31498AL1/640/31498AL1.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Zestaw startowy Mono z wylewką w kształcie C ",
		"textblock_1st_text": "31498AL1",
		"textblock_2nd_text": "GROHE Blue Home Mono starter kit: pillar tap in Brushed Hard Graphite for filtered, chilled and sparkling water, with Bluetooth® & WIFI*, high C-spout. Includes cooler unit, filter and CO2 carbonization bottle. 31498AL1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/31498AL1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455DL1",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455DL1/640/31455DL1.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Zestaw startowy z wylewką w kształcie C",
		"textblock_1st_text": "31455DL1",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: kitchen tap in Brushed Warm Sunset for filtered, chilled and sparkling water, with Bluetooth® & WIFI*, high C-spout. Includes cooler unit, filter and CO2 carbonization bottle. 31455DL1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/31455DL1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455AL1",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455AL1/640/31455AL1.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Zestaw startowy z wylewką w kształcie C",
		"textblock_1st_text": "31455AL1",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: kitchen tap in Brushed Hard Graphite for filtered, chilled and sparkling water, with Bluetooth® & WIFI*, high C-spout. Includes cooler unit, filter and CO2 carbonization bottle. 31455AL1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/31455AL1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454DL1",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454DL1/640/31454DL1.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Zestaw startowy z wylewką w kształcie L",
		"textblock_1st_text": "31454DL1",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: kitchen tap in Brushed Warm Sunset for filtered, chilled and sparkling water, with Bluetooth® & WIFI*, high L-spout. Includes cooler unit, filter and CO2 carbonization bottle. 31454DL1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/31454DL1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454AL1",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454AL1/640/31454AL1.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Zestaw startowy z wylewką w kształcie L",
		"textblock_1st_text": "31454AL1",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: kitchen tap in Brushed Hard Graphite for filtered, chilled and sparkling water, with Bluetooth® & WIFI*, high L-spout. Includes cooler unit, filter and CO2 carbonization bottle. 31454AL1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/31454AL1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "40841001",
		"image": "//cdn.cloud.grohe.com/prod/40/40/40841001/640/40841001.jpg",
		"headline": "GROHE Red",
		"subheadline": "Zawór mieszający",
		"textblock_1st_text": "40841001",
		"textblock_2nd_text": "No value for EndUserShort",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/40841001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327AL1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327AL1/640/30327AL1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Wylewka i bojler w rozmiarze M",
		"textblock_1st_text": "30327AL1",
		"textblock_2nd_text": "GROHE RED Duo kitchen tap with high L-spout in Brushed Hard Graphite. Includes filter set and M size boiler for instant boiling water. A-rated energy efficiency and safety features. 30327AL1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/30327AL1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30085DL1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30085DL1/640/30085DL1.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Zawór sztorcowy i bojler w rozmiarze M",
		"textblock_1st_text": "30085DL1",
		"textblock_2nd_text": "GROHE RED Mono pillar tap with high C-spout in Brushed Warm Sunset. Includes filter set and M size boiler for instant boiling water. A-rated energy efficiency and safety features. 30085DL1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/30085DL1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30085AL1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30085AL1/640/30085AL1.jpg",
		"headline": "GROHE Red Mono",
		"subheadline": "Zawór sztorcowy i bojler w rozmiarze M",
		"textblock_1st_text": "30085AL1",
		"textblock_2nd_text": "GROHE RED Mono pillar tap with high C-spout in Brushed Hard Graphite. Includes filter set and M size boiler for instant boiling water. A-rated energy efficiency and safety features. 30085AL1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/30085AL1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454001",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454001/640/31454001.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Zestaw startowy z wylewką w kształcie L",
		"textblock_1st_text": "31454001",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: single-lever kitchen mixer for filtered, chilled and sparkling water, with Bluetooth® & WIFI*. Includes cooler unit, filter and CO2 carbonization bottle. High swivel L-spout, chrome finish.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/31454001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454DC1/640/31454DC1.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Zestaw startowy z wylewką w kształcie L",
		"textblock_1st_text": "31454DC1",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: single-lever kitchen mixer for filtered, chilled and sparkling water, with Bluetooth® & WIFI*. Includes cooler unit, filter and CO2 carbonization bottle. High swivel L-spout, stainless steel-look.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/31454DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455DC1",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455DC1/640/31455DC1.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Zestaw startowy z wylewką w kształcie C",
		"textblock_1st_text": "31455DC1",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: single-lever kitchen mixer for filtered, chilled and sparkling water, with Bluetooth® & WIFI*. Includes cooler unit, filter and CO2 carbonization bottle. High swivel C-spout, stainless steel-look.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/31455DC1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455001",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455001/640/31455001.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Zestaw startowy z wylewką w kształcie C",
		"textblock_1st_text": "31455001",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: single-lever kitchen mixer for filtered, chilled and sparkling water, with Bluetooth® & WIFI*. Includes cooler unit, filter and CO2 carbonization bottle. High swivel C-spout, chrome finish.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/31455001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30083KS1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30083KS1/640/30083KS1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Wylewka i bojler w rozmiarze M",
		"textblock_1st_text": "30083KS1",
		"textblock_2nd_text": "GROHE RED Duo kitchen tap (C-spout) with filter set and M size boiler for instant boiling water. Velvet black finish. A-rated energy efficiency and safety features. 30083KS1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/30083KS1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "30327KS1",
		"image": "//cdn.cloud.grohe.com/prod/30/30/30327KS1/640/30327KS1.jpg",
		"headline": "GROHE Red Duo",
		"subheadline": "Wylewka i bojler w rozmiarze M",
		"textblock_1st_text": "30327KS1",
		"textblock_2nd_text": "GROHE RED Duo kitchen tap (L-spout) with filter set and M size boiler for instant boiling water. Velvet black finish. A-rated energy efficiency and safety features. 30327KS1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/30327KS1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G274_KI",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31454KS1",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31454KS1/640/31454KS1.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Zestaw startowy z wylewką w kształcie L",
		"textblock_1st_text": "31454KS1",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: single-lever kitchen mixer for filtered, chilled and sparkling water, with Bluetooth & WIFI*. Includes cooler unit, filter and CO2 carbonization bottle. High swivel L-spout, velvet black finish. 31454KS1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/31454KS1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "31455KS1",
		"image": "//cdn.cloud.grohe.com/prod/30/31/31455KS1/640/31455KS1.jpg",
		"headline": "GROHE Blue Home",
		"subheadline": "Zestaw startowy z wylewką w kształcie C",
		"textblock_1st_text": "31455KS1",
		"textblock_2nd_text": "GROHE Blue Home Duo starter kit: single-lever kitchen mixer for filtered, chilled and sparkling water, with Bluetooth & WIFI*. Includes cooler unit, filter and CO2 carbonization bottle. High swivel C-spout, velvet black finish. 31455KS1",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.pl/pl_pl/product/31455KS1",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.pl/pl_pl/grohe/salony-sprzedazy.html#productline=G503",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/water_products_pl_pl.json
// module id = 885
// module chunks = 0